<div id="reset-password" class="flex flex-col" fusePerfectScrollbar>
  <div
    id="reset-password-form-wrapper"
    class="flex flex-col justify-center items-center"
    *fuseIfOnDom
    [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
    <div id="reset-password-form">
      <div class="logo">
        <img src="./assets/images/logos/fuse.svg" />
      </div>

      <div i18n class="title">ИЗМЕНЕНИЕ ПАРОЛЯ</div>

      <form name="resetPasswordForm" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" novalidate>
        <mat-form-field appearance="outline">
          <mat-label i18n>Новый пароль</mat-label>
          <input matInput formControlName="password" />
          <mat-error i18n *ngIf="resetPasswordFormErrors.password.required">Пароль не задан</mat-error>
          <mat-error
            i18n
            *ngIf="!resetPasswordFormErrors.password.required && resetPasswordFormErrors.password.minLength"
            >Минимальная длина - {{ resetPasswordFormErrors.password.minlength.requiredLength }}</mat-error
          >
        </mat-form-field>

        <button
          i18n
          mat-raised-button
          class="submit-button"
          color="accent"
          aria-label="RESET MY PASSWORD"
          [disabled]="resetPasswordForm.invalid"
          >ИЗМЕНИТЬ ПАРОЛЬ</button
        >
      </form>

      <div class="login" *ngIf="userOrign">
        <a i18n class="link" href="{{ userOrign }}" target="_self">Вернуться на страницу авторизации</a>
      </div>
    </div>
  </div>
</div>
